import { delay } from './delay';

export async function conditionallyRunWithRetry<T>(
    action: () => T,
    predicate: () => boolean,
    times: number,
    delayMs: number,
): Promise<void> {
    for (let i = 0; i < times; i++) {
        if (predicate()) {
            await action();
            return;
        } else {
            await delay(delayMs);
        }
    }
}
